import styled from 'styled-components';

import ReactSelect from '../../../../../../../../../Common/SelectDropdown/SelectDropdown';

export default styled(ReactSelect)``;
